import { useEffect, useState } from "react";
import "../../container/styles.css";
import TextInput from "../TextInput";
import ApiService from "../../api/ApiServices";
import ChallengeSuccessModalProps from "../ChallengeSuccessModal";
import AlertModal from "../AlertModal";

const HomeDancePicFragment = ({
  onClick,
  hideOptions = false,
  imgStyle = null,
  contStyle = null,
  img,
  id,
  onCompleted,
}: {
  onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
  hideOptions?: boolean;
  imgStyle?: any;
  contStyle?: any;
  img?: any;
  id?: any;
  onCompleted?: any;
}) => {
  const [inputValue, setInputValue] = useState("");
  const [submitLoad, setSubmitLoad] = useState<boolean>(false);
  const [isChallengeCompleted, setIsChallengeCompleted] = useState<boolean>(false);
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>("Challenge completed");
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("");

  const openAlert = (message: string) => {
    setAlertMessage(message);
    setShowAlert(true);
  };

  const checkChallengeCompleted = async (challengeId: string) => {
    try {
      const availableResponse = await ApiService.getAvailableChallenges();
      const availableChallenges = availableResponse?.data || [];

      const isAvailable = availableChallenges?.some((item: any) => {
        const availableId = item?._id || item?.challengeId?._id || item?.challengeId;
        return availableId === challengeId;
      });

      setIsChallengeCompleted(!isAvailable);
    } catch (error) {
      setIsChallengeCompleted(false);
    }
  };

  const handleSubmit = async () => {
    if (!id || !inputValue.trim() || submitLoad || isChallengeCompleted) {
      if (!inputValue.trim()) {
        openAlert("please add some text");
      }
      return;
    }

    try {
      setSubmitLoad(true);
      const response = await ApiService.answerText({
        challengeId: id,
        answer: inputValue.trim(),
      });

      if (response?.status) {
        setSuccessMessage(response?.message || "Challenge completed");
        setShowSuccessModal(true);
        setInputValue("");
        setIsChallengeCompleted(true);
      }
    } catch (error) {
      openAlert("Unable to submit challenge");
    } finally {
      setSubmitLoad(false);
    }
  };

  useEffect(() => {
    if (id) {
      checkChallengeCompleted(id);
    }
  }, [id]);

  return (
    <>
    <ChallengeSuccessModalProps
      visible={showSuccessModal}
      message={successMessage}
      onConfirm={() => {
        setShowSuccessModal(false);
        onCompleted && onCompleted();
      }}
    />
    <AlertModal
      visible={showAlert}
      title="Error"
      message={alertMessage}
      onConfirm={() => setShowAlert(false)}
    />
    <div className="home-frag-cont">
      <div
        onClick={onClick}
        className={`flex flex-col flex-1 relative ${
          !hideOptions && `mr-3`
        }
      ${contStyle && contStyle}
      `}
      >
        <img
          alt=""
          className={`home-frag-img ${imgStyle}`}
          src={img || require("../../assets/danceFrag.png")}
        />
      </div>
      {!isChallengeCompleted && (
        <div className="flex flex-row items-center">
          <TextInput
            placeholder="Enter your answer..."
            value={inputValue}
            containerStyles="ml-1 pl-2 py-2 my-2 flex flex-1"
            onChange={(e: any) => setInputValue(e.target.value)}
            textInputStyles={{ maxWidth: "96%", paddingLeft: 4, paddingRight: 4 }}
          />
          <div
            className={`primary-btn challenge-sml-btn flex px-1 py-1 mx-2 ${submitLoad ? "opacity-70 cursor-not-allowed" : ""}`}
            onClick={handleSubmit}
          >
            <div className={`inter-12-bold text-white px-1 cursor-pointer`}>
              {submitLoad ? "..." : "SUBMIT"}
            </div>
          </div>
        </div>
      )}
      </div>
    </>
  );
};

export default HomeDancePicFragment;
